/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportAIModelRequest
 */
export interface ImportAIModelRequest {
    /**
     * 
     * @type {string}
     * @memberof ImportAIModelRequest
     */
    path: string;
}

export function ImportAIModelRequestFromJSON(json: any): ImportAIModelRequest {
    return ImportAIModelRequestFromJSONTyped(json, false);
}

export function ImportAIModelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportAIModelRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': json['path'],
    };
}

export function ImportAIModelRequestToJSON(value?: ImportAIModelRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
    };
}


